<template>
  <div class="appdownload-v2 white section-gap">
    <v-container grid-list-xl pb-0>
      <div class="appdownload-layout">
        <div class="appdownload-copy">
          <div class="sec-title mb-3">
            <h2 class="text-left">{{ secTitle }}</h2>
          </div>
          <h6 class="text-left">Fast, Simple & Delightful.</h6>
          <h6 class="text-left">All it takes is 30 seconds to Download.</h6>
          <div class="appdownload-stores d-flex justify-start mt-3">
            <a :href="playStore" target="_blank" class="mr-2">
              <img
                src="/static/images/revised/play-store.png"
                class="img-fluid"
                alt="Get it on Google Play"
              />
            </a>
            <a :href="appStore" target="_blank" class="mr-2">
              <img
                src="/static/images/revised/app-store.png"
                class="img-fluid"
                alt="Download on the App Store"
              />
            </a>
          </div>
        </div>
        <div class="appdownload-visual">
          <img
            src="static/images/revised/Downloadourapp2.jpeg"
            alt="TradeBridge mobile app"
          />
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import AppConfig from "Constants/AppConfig";
export default {
  props: ["data", "secTitle"],
  data() {
    return {
      appStore: AppConfig.appStore,
      playStore: AppConfig.playStore,
    };
  },
  mounted() {
    this.appStore = AppConfig.appStore;
    this.playStore = AppConfig.playStore;
  },
};
</script>
<style scoped>
.appdownload-layout {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.75rem;
}
.appdownload-copy {
  flex: 0 0 auto;
  position: relative;
  z-index: 1;
}
.appdownload-copy h2 {
  white-space: nowrap;
}
.appdownload-stores {
  max-width: 350px;
}
.appdownload-visual {
  flex: 0 0 460px;
  width: 460px;
  height: 597px;
  overflow: hidden;
}
.appdownload-visual img {
  display: block;
  width: 149.3%;
  max-width: none;
  height: auto;
  margin-left: -24.8%;
  margin-top: -10.6%;
}
@media (max-width: 1100px) {
  .appdownload-visual {
    flex-basis: 380px;
    width: 380px;
    height: 493px;
  }
}
@media (max-width: 959px) {
  .appdownload-layout {
    flex-direction: column;
    gap: 1.25rem;
  }
  .appdownload-copy h2,
  .appdownload-copy h6 {
    text-align: center !important;
  }
  .appdownload-stores {
    justify-content: center !important;
    margin-left: auto;
    margin-right: auto;
  }
  .appdownload-visual {
    flex-basis: auto;
    width: min(100%, 340px);
    height: auto;
    aspect-ratio: 564 / 732;
  }
}
</style>
